import { render } from "./ContactSuccess.vue?vue&type=template&id=57e986a0&scoped=true&ts=true"
import script from "./ContactSuccess.vue?vue&type=script&lang=ts"
export * from "./ContactSuccess.vue?vue&type=script&lang=ts"

import "./ContactSuccess.vue?vue&type=style&index=0&id=57e986a0&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57e986a0"]])

export default __exports__